import { useEffect, useRef } from "react";
import { useNavigate } from "react-router";
import { getRequest, getRequestWithAuth } from "~/lib/api";
import { setSession, setUser } from "~/lib/session";
import { useAuth } from "~/contexts/AuthContext";
import AuthLoading from "~/components/auth-loading/auth-loading";

export default function GoogleCallback() {
  const navigate = useNavigate();
  const { refreshAuth } = useAuth();
  const processingRef = useRef(false);

  useEffect(() => {
    const handleCallback = async () => {
      // Prevent double execution from React Strict Mode
      if (processingRef.current) return;
      processingRef.current = true;

      try {
        const urlParams = new URLSearchParams(window.location.search);
        const paramsObj = Array.from(urlParams.keys()).reduce(
          (acc, val) => ({ ...acc, [val]: urlParams.get(val) }),
          {}
        );
        const googleCallbackPath = `/api/v1/auth/google/callback`;
        const data = await getRequest(googleCallbackPath, { params: paramsObj });
        setSession(data.access_token, data.token_type);
        const user = await getRequestWithAuth("/api/v1/users/me");
        setUser(user);

        // Refresh auth context with new user
        await refreshAuth();

        navigate("/app");
      } catch (error) {
        console.error("Google auth callback failed:", error);
        navigate("/");
      }
    };

    handleCallback();
  }, [navigate, refreshAuth]);

  return <AuthLoading />;
}
